module.exports = __webpack_public_path__ + "assets/img/Record.6ee2216e.png";